export default "__VITE_ASSET__CR8uPQYH__"